var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { attrs: { "body-style": "padding:0 0 20px 0;" } },
        [
          _c("ueditorFrom", {
            ref: "ueditorFrom",
            attrs: {
              border: true,
              height: _vm.height,
              "main-width": "800px",
              "editor-border": false,
              placeholder:
                "建议从营收、利润、规模、人才、管理、产品、市场八大维度进行战略规划制定",
              content: _vm.content,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "cr-bottom-button btn-shadow" },
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "hasPermi",
                  rawName: "v-hasPermi",
                  value: ["hr:training:plan:save"],
                  expression: "['hr:training:plan:save']",
                },
              ],
              attrs: { size: "small", loading: _vm.loading, type: "primary" },
              on: {
                click: function ($event) {
                  return _vm.handleConfirm()
                },
              },
            },
            [_vm._v("保存")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }